module.exports = seamlessLogger;